import { render } from "./exchanges.vue?vue&type=template&id=2888ec11"
import script from "./exchanges.vue?vue&type=script&lang=js"
export * from "./exchanges.vue?vue&type=script&lang=js"

import "./exchanges.vue?vue&type=style&index=0&id=2888ec11&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__